import React from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../stores/ToastStore';
import { useHandleDeleteDocuments, useRetryUploadDocuments, } from '../../../utils/DocumentsHooks';
export function FailedDocument({ document, onDelete }) {
    const { t } = useTranslation();
    const [retryUploadDocuments] = useRetryUploadDocuments();
    const { handleDelete } = useHandleDeleteDocuments(() => {
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(document);
    });
    const handleRetryUpload = (documentId) => {
        const retryResult = retryUploadDocuments([documentId]);
        if (retryResult.error) {
            showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', { error: retryResult.error }), 'error');
        }
    };
    return (React.createElement("div", { className: "flex flex-col relative" },
        React.createElement("div", { className: "flex justify-center align-middle mb-4" },
            React.createElement("i", { className: "icon glyphicon glyphicon-alert text-orange" }),
            React.createElement("span", null, t('DOCUMENT_UPLOAD_FAILED_RETRY'))),
        React.createElement("button", { type: "button", className: "button button-hollow-red", onClick: handleRetryUpload(document.id) }, t('RETRY_UPLOAD')),
        React.createElement("i", { className: "icon glyphicon glyphicon-remove text-red cursor-pointer -top-2 -right-2 absolute", onClick: () => handleDelete([document]) })));
}
